import script from "./Appagency.vue?vue&type=script&setup=true&lang=js"
export * from "./Appagency.vue?vue&type=script&setup=true&lang=js"

import "./Appagency.vue?vue&type=style&index=0&id=62e1e532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62e1e532"]])

export default __exports__